import ConversationMessageRecord from "models/view-models/conversations/conversation-message-record";
import HitRecord from "models/view-models/search/hit-record";
import { CitationInfo } from "organisms/modals/chat-modal/chat-citation";
import { useEffect, useRef, useState } from "react";

export function useCitations(
    message: ConversationMessageRecord,
    citations: HitRecord[]
) {
    const [citationsList, setCitationsList] = useState<CitationInfo[]>([]);

    const citationMap = useRef(new Map<number, number>());
    const nextNumberRef = useRef(1);

    useEffect(() => {
        const inlineList: CitationInfo[] = [];
        const nonInlineList: CitationInfo[] = [];

        // Add inline citations
        citationMap.current.forEach((displayNumber, citationIndex) => {
            const citation = citations?.[citationIndex];
            if (citation) inlineList.push({ citation, displayNumber });
        });

        // Add non-inline citations
        citations?.forEach((citation, index) => {
            if (!citationMap.current.has(index)) {
                nonInlineList.push({
                    citation,
                    displayNumber: 0,
                });
            }
        });

        const combinedList = [...inlineList, ...nonInlineList];

        setCitationsList(combinedList);
    }, [message.content, citations]);

    return {
        citationMap: citationMap.current,
        nextNumberRef,
        citationsList,
    };
}
